import { Ship, MessageSquare } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useEffect, useState } from "react";
import bgRoughSea from "@/assets/bg-rough-sea.jpg";

const Hero = () => {
  const [isImageLoaded, setIsImageLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = bgRoughSea;
    img.onload = () => {
      setIsImageLoaded(true);
      setHasError(false);
    };
    img.onerror = () => {
      setHasError(true);
      setIsImageLoaded(false);
    };
  }, []);

  return (
    <header className="w-full py-28 text-center animate-fadeIn relative overflow-hidden ">
      {!hasError && (
        <>
          {/* High-quality image */}
          <div
            className="absolute inset-0 opacity-10 bg-cover bg-center bg-no-repeat z-0 w-screen transition-opacity duration-300 mix-blend-overlay"
            style={{
              backgroundImage: `url(${bgRoughSea})`,
              opacity: isImageLoaded ? 1 : 0
            }}
            aria-hidden="true"
          />
          {/* Dark overlay */}
          <div
            className="absolute inset-0 bg-gradient-to-b from-navy/70 to-navy/80 z-0"
            aria-hidden="true"
          />
        </>
      )}
      <div className="container mx-auto relative z-10">
        <div className="w-20 h-20 mx-auto mb-6 bg-sunset rounded-full flex items-center justify-center animate-float">
          <Ship className="w-12 h-12 text-navy" />
        </div>
        <h1 className="font-serif font-bold text-5xl md:text-6xl pb-4 bg-gradient-to-r from-ocean via-sunset to-ocean bg-clip-text text-transparent">
          The Flying Dutchman
        </h1>
        <p className="text-xl text-ocean mb-8">Where Skill Meets Community</p>
        <p className="max-w-2xl mx-auto text-lg text-gray-300 mb-8">
          We are a thriving World of Warships community on the EU server, founded in 2017.
          Growing steadily over the years, we've become one of the larger active communities
          with over 80 passionate players across our family of three clans. Each clan serves
          its own unique purpose, creating a perfect blend of competitive gameplay and casual
          fun that makes TFD special.
        </p>
        <Button
          variant="outline"
          className="bg-transparent hover:bg-sunset/10 border-sunset/30 hover:border-sunset text-ocean hover:text-sunset"
          onClick={() => window.open("https://discord.gg/29gn3mXqtA", "_blank")}
        >
          <MessageSquare className="w-5 h-5 mr-2" />
          Join our Community
        </Button>
      </div>
    </header>
  );
};

export default Hero;
